import { useEffect } from "react";
import useRestaurants from "../../hooks/Restaurant/useRestaurants";
import RestaurantList from "../Restaurants/RestaurantList";
import ProposalCreateRestaurant from "./ProposalCreateRestaurant";
import Spinner from "../../components/ui/spinner";

const HomePage = () => {
  const { restaurants, loading, error, refetchRestaurants } = useRestaurants({
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });

  useEffect(() => {
    refetchRestaurants();
  }, [refetchRestaurants]);

  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;
  
  // NEED TO DO: double restaurant query
  if (restaurants?.length === 0) {
    return <ProposalCreateRestaurant />;
  }

  return<RestaurantList />
}

export default HomePage;
